import { GameCanvas } from "./components/GameCanvas";
import "./index.css";

export function App() {
  return (
    <div className="w-full h-full">
      <GameCanvas />
    </div>
  );
}

export default App;
